<template>
  <v-row>

      <!-- Titulo quemado de Procuraduría  -->
    <div style="margin-bottom:3rem;">
      <p class="text-left font-weight-black"
         style="color: #616060; width: 50%;font-size: 37px;">
        {{ themeTitle }}
      </p>
      <p class="text-left" style="color: #616060; width: 40%; font-size: 18px;">
        {{subtitle}}
      </p>
    </div>

    <v-col cols="12" md="12" lg="12">
      <!-- PRIMER FORMULARIO, DOSTOS PERSONALES Y DOMICILIO -->
      <v-card flat class="pa-6" color="transparent" v-if="stepRegister===''">
        <v-card-title class="d-flex justify-center" style="color: #616060; font-size: 30px;">
          Crea tu cuenta
        </v-card-title>

        <v-card-text @click="registerRequest.user_type = 'username'; registerRequest.tipo_persona = 'fisica'">
          <v-form ref="preregisterForm" v-model="preregisterFormValid">
            <div class="title_datos">
              <p>Datos personales</p>
            </div>
            <v-row>
              <v-col cols="12" md="6">

                <div class="mb-2" >* CURP</div>
                <v-text-field
                    tabindex="1"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.curp"
                    placeholder="Ingresa una CURP válida."
                    @click:append="help('Ingresa su CURP correctamente.')"
                    :rules="[formValidator.curp.pattern_valid,v => (v && v.length === 18) || 'La CURP debe tener 18 caracteres.']"
                    :loading="curpLoading"
                    :error="curpError"
                    :error-messages="curpMessage"
                    minLength="2"
                    maxlength="18"
                >
                </v-text-field>

                <div class="mb-2" >* Primer Apellido</div>
                <v-text-field
                    tabindex="3"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.apellido_paterno"
                    placeholder="Ingresa tu apellido paterno"
                    :rules="[formValidator.lastname_pat.required]"
                />

                <div class="mb-2" >* Nombre(s)</div>
                <v-text-field
                    tabindex="5"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.nombres"
                    placeholder="Ingresa tu nombre"
                    :rules="[formValidator.name.required]"
                />

                <div class="mb-2" >* Contraseña</div>
                <v-text-field
                    tabindex="7"
                    class="custom-input"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[formValidator.password.required, formValidator.password.min]"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Ingresa una contraseña que puedas recordar con facilidad."
                    hint="Ingresa una contraseña que puedas recordar con facilidad"
                    @click:append="showPassword = !showPassword"
                    outlined
                    required
                    v-model="registerRequest.password"
                />
              </v-col>

              <v-col cols="12" md="6">
                <div class="mb-2" >RFC</div>
                <v-text-field
                    tabindex="2"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.rfc"
                    placeholder="Ingresa un RFC válido"
                    :rules="[formValidator.rfc.physic_pattern_valid]"
                />

                <div class="mb-2" >Segundo Apellido</div>
                <v-text-field
                    tabindex="4"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.apellido_materno"
                    placeholder="Apellido materno"
                />

                <div class="mb-2" >* Correo electrónico</div>
                <v-text-field
                    tabindex="6"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.email"
                    placeholder="Proporciona un correo electrónico válido"
                    :append-icon="'mdi-help'"
                    @click:append="help('El correo que proporciones será el medio por el cual nos estaremos comunicando contigo en caso de ser necesario. Por tal razón, asegúrate de que esté correctamente escrito.')"
                    :rules="[formValidator.email.required, formValidator.email.valid_email]"
                    type="email"
                />

                <div class="mb-2" >Repite la contraseña</div>
                <v-text-field
                    tabindex="8"
                    class="custom-input"
                    :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[formValidator.password.passwordMatch(registerRequest.password_confirm, registerRequest.password)]"
                    :type="showRepeatPassword ? 'text' : 'password'"
                    placeholder="Confirma la contraseña"
                    @click:append="showRepeatPassword = !showRepeatPassword"
                    outlined
                    required
                    v-model="registerRequest.password_confirm"
                />
              </v-col>

            </v-row>
            <!--
            <div class="title_datos">
              <p>Domicilio</p>
            </div>
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <div class="mb-2" >Estado</div>
                <v-select
                    tabindex="9"
                    class="custom-input"
                    v-model="selectedEstado"
                    :items="estados"
                    item-value="cve_agee"
                    item-text="nom_agee"
                    label="Selecciona un estado"
                    outlined
                ></v-select>

                <div class="mb-2" >Colonia</div>
                <v-select
                    tabindex="11"
                    class="custom-input"
                    label="Colonia"
                    v-model="selectedColonia"
                    :items="colonias"
                    item-title="nombre"
                    item-value="id"
                    @update:modelValue="fetchUbicaciones('cp')"
                    outlined
                    required
                    :disabled="!selectedMunicipio"
                />
                <div class="mb-2" >No. Exterior</div>
                <v-text-field
                    tabindex="13"
                    class="custom-input"
                    v-model="numExt"
                    outlined
                    required
                    placeholder="No. Exterior"
                />
              </v-col>

              <v-col cols="12" md="6" lg="6">
                <div class="mb-2" >Municipio</div>
                <v-select
                    tabindex="10"
                    class="custom-input"
                    label="Municipio"
                    v-model="selectedMunicipio"
                    :items="municipios"
                    item-title="nombre"
                    item-value="id"
                    @update:modelValue="fetchUbicaciones('colonias')"
                    outlined
                    required
                    :disabled="!selectedEstado"
                />
                <div class="mb-2" >Codigo Postal</div>
                <v-select
                    tabindex="12"
                    class="custom-input"
                    label="Código Postal"
                    v-model="selectedCP"
                    :items="codigosPostales"
                    item-title="codigo"
                    item-value="codigo"
                    outlined
                    required
                    :disabled="!selectedColonia"
                />
                <div class="mb-2" >No. Interior"</div>
                <v-text-field
                    tabindex="14"
                    class="custom-input"
                    v-model="numInt"
                    placeholder="No. Interior"
                    outlined/>
              </v-col>
            </v-row> -->

            <div style="display: flex; align-items: center; justify-content: center; margin: 10px">
              <v-checkbox
                  solo
                  color="main_color_action"
                  v-model="termAndCondition"
                  :rules="[formValidator.term_and_condition.required]"
                  style="align-self: center; margin: 0; padding: 0; transform: translateY(10px);"
              />
              <div class="v-label" style="color: #616060; margin-left: 8px;">
                He leído y entendido
                <a class="font-weight-bold" @click="showTermsCondDialog(true)">el aviso de privacidad</a> y acepto
                <a class="font-weight-bold" @click="showTermsCondDialog(false)">los términos y condiciones</a> del sistema.
              </div>
            </div>

<!--            <div style="display: flex; margin-bottom: 2rem; justify-content: center" >-->
<!--              <div class="block">-->
<!--                <v-alert type="error" v-if="captchaError">-->
<!--                  Verifica el captcha por favor-->
<!--                </v-alert>-->
<!--                <vue-recaptcha-->
<!--                    :sitekey="getCaptchaSiteKey()"-->
<!--                    :loadRecaptchaScript="true"-->
<!--                    @verify="verifyReCaptcha"-->
<!--                    @expired="expiredRecaptcha"-->
<!--                    class="custom-input">-->
<!--                </vue-recaptcha>-->
<!--              </div>-->
<!--            </div>-->

            <div class="d-flex justify-center align-center" style="width: 100%;">
              <div class="block justify-center" style="width: 30%;">
                <div class="flex justify-center mb-2">
                  <v-btn block @click="nextStepToRegister" color="main_color_action" large class="flex-fill mr-2"
                         style="color: white;">Siguiente
                  </v-btn>
                </div>

                <p class="pregunta" style="margin: 0; text-align: center; color: #616060; font-size: 18px">
                  ¿Ya tienes una cuenta?
                  <span class="font-weight-black" style="cursor: pointer" @click.stop="$router.push('/login')">
                  Inicia Sesión
                </span>

                </p>
              </div>
            </div>

          </v-form>
        </v-card-text>
      </v-card>
      <!-- SEGUNDO FORMULARIO MEDIOS DE COMUNICACION -->
      <v-card flat class="pa-6" color="transparent" v-if="stepRegister==='MediosDeContacto'">
        <v-card-title class="d-flex justify-center" style="color: #616060; font-size: 30px;">
          Medios de contacto
        </v-card-title>
        <v-card-text>
          <v-form>
            <div class="title_datos">
            <p>Medios de contacto</p>
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <div class="mb-2" >Número celular</div>
                <v-text-field
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.telefono"
                    placeholder="Proporciona un número de teléfono válido"
                    title="El Numero que proporciones será el medio por el cual nos estaremos comunicando contigo,
                              en caso de ser necesario. Por tal razón, asegúrate de que esté correctamente escrito."
                    :rules="[formValidator.telefono.digits_10]"
                    type="telefono"
                    maxlength="10"
                />
                <div class="mb-2" >* Correo electrónico</div>
                <v-text-field
                    tabindex="6"
                    class="custom-input"
                    outlined
                    required
                    v-model="registerRequest.email"
                    :placeholder= "registerRequest.email || 'Proporciona un correo electrónico válido'"
                    type="email"
                    readonly
                />
              </v-col>
              <v-col cols="12" md="6">
                  <div class="mb-2" style="">Confirma tu número celular</div>
                    <v-text-field
                        class="custom-input"
                        outlined
                        required
                        v-model.lazy="confirmarTelefono"
                        placeholder="Confirma tu número de teléfono"
                        :rules="[formValidator.telefono.telefonoMatch(registerRequest.telefono, confirmarTelefono)]"
                        type="telefono"
                        maxlength="10"
                    />
                <div class="mb-2" >Confirma tu Correo electronico</div>
                  <v-text-field
                    class="custom-input"
                    outlined
                    required
                    v-model.lazy="confirmarEmail"
                    type="email"
                    :rules="[formValidator.email.emailMatch(registerRequest.email, confirmarEmail)]"
                    placeholder="Confirma tu correo electronico"
                    />
              </v-col>
            </v-row>
            <div class="confirm" style="display: flex; align-items: center; justify-content: center; margin: 10px; width: 50%;">
              <v-checkbox
                  v-model="isChecked"
                  solo
                  color="main_color_action"
                  style="align-self: center; margin: 0; padding: 0; transform: translateY(10px);"
              />
              <div class="v-label" style="color: #616060; margin-left: 8px;">
                Acepto el uso de estos medios de contacto como medios oficiales para recibir notificaciones y comunicaciones relacionadas con cualquier tramite  o servicio, de acuerdo con los tierminos y condiciones aplicadas
              </div>
            </div>
            <div class="d-flex justify-center align-center" style="width: 100%; margin-top: 3rem">
            <div class="block justify-center" style="width: 50%;">
              <div class="flex justify-center mb-2">
                <v-btn block :disabled="!isChecked" @click="nextStepToRegister" color="main_color_action" large class="flex-fill mr-2"
                       style="color: white;">Siguiente
                </v-btn>
                <v-btn block @click="backRegister" color="main_color_action" large class="flex-fill mr-2"
                       style="color: white; margin-top: 2rem">Retroceder
                </v-btn>
              </div>
            </div>
            </div>


          </v-form>
        </v-card-text>
      </v-card>
      <!-- TERCER FORMULARIO, VERIFICACION DE CONTACTO -->
      <v-card flat class="pa-6" color="transparent" v-if="stepRegister==='VerificacionContacto'">
        <v-card-title class="d-flex justify-center" style="color: #616060; font-size: 30px;">
        Verificación de medios de contacto
        </v-card-title>
        <div class="pa-6 d-flex justify-center">
          <p style="color: #616060; font-size: 20px; width: 40%; text-align: justify;" class="nota">
            "Hemos enviado códigos de verificación a tus medios de contacto para confirmar que son correctos. Por favor, ingresa los códigos que recibiste."
          </p>
        </div>
        <v-container class="d-flex justify-center align-center" style = "margin-top: 50px">
          <v-form style="width: 30%" color="transparent" class="ingresocode">
            <v-row justify="center">
              <v-col cols="2" style="width: 100%;">
                <div class="mb-2 text-center">Código por correo</div>
                <v-text-field
                    class="custom-input"
                    outlined
                    required
                    v-model="emailCode"
                    placeholder="Ingresa el código que recibiste por email"
                    :rules="[formValidator.code.required, formValidator.code.length(6)]"
                    maxlength="6"
                />
                <div class="mb-2 text-center">Código por SMS</div>
                <v-text-field
                    class="custom-input"
                    outlined
                    required
                    v-model="phoneCode"
                    placeholder="Ingresa el código que recibiste por teléfono"
                    :rules="[formValidator.code.required, formValidator.code.length(6)]"
                    maxlength="6"
                />
              </v-col>
            </v-row>
            <v-btn block @click="resendVerificationCodeSame" color="main_color_action" large class="flex-fill mr-2"
                   style="color: white; margin-top: 2rem">Validar codigos
            </v-btn>
            <v-btn block @click="resentCodeFirst" color="main_color_action" large class="flex-fill mr-2" :disabled="isDisabled"
                   style="color: white; margin-top: 2rem"> {{ isDisabled ? `Espera ${countdown}s` : 'Reenviar códigos' }}
            </v-btn>
          </v-form>
        </v-container>


      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import registerFormValidator from "../form/register.form.validator";
import {registerRequest} from "../api/models";
//import {createStrongPassword} from "../core/utils";
// import VueRecaptcha from 'vue-recaptcha'
import {GeneralApi} from "@/api";
import moment from "moment"


export default {
  data() {
    return {
      isChecked: false,
      stepRegister: '',
      showAlert : false,
      envLogo: process.env.VUE_APP_LOGO,
      recaptchaVerified: false,
      personTypeItems: [{label: 'Persona física', code: 'fisica'}, {label: 'Persona moral', code: 'moral'}],
      formValidator: registerFormValidator,
      preregisterFormValid: false,
      registerFormValid: false,
      registerMoralFormValid: false,
      showPassword: false,
      showRepeatPassword: false,
      registerRequest: registerRequest(),
      confirmarTelefono: '',
      confirmarEmail: '',
      showNextForm: true,
      emailCode: '',
      phoneCode: '',
      curpLoading: false,
      curpError: false,
      curpMessage: '',
      termAndCondition: false,
      showTermsDialog: false,
      privacyContent: true,
      captchaError: false,
      showHelpMessage: false,
      helpMessage: "",
      sexoRegistro: '',
      // otros datos:
      date: null,
      menu: false,
      modal: false,
      menu2: false,
      activePicker: null,
      // para el count down de del boton de reenviar codigo
      isDisabled: false,
      countdown: 10
    }
  },

  // components: {VueRecaptcha},
  created() {
    this.$gtag.event('registro', {method: 'Google'}) // Google Analytics
  },
  computed: {
    ...mapState({ accountStore: (state) => state.account }),
    themeTitle() {
      // Detecta si el tema es claro u oscuro
      const theme = this.$vuetify.theme.dark ? "dark" : "light";
      return this.$vuetify.theme.themes[theme]?.texts.title_login || "Título por defecto";
    },
    subtitle(){
      const theme = this.$vuetify.theme.dark ? "dark" : "light";
      return this.$vuetify.theme.themes[theme]?.texts.subtitle_login || "Título por defecto";
    },

    consentContactoComputed: {
      get() {
        return this.consentContacto;
      },
      set(value) {
        this.consentContacto = value ? 'true' : 'false';
      },
    },
  },
  watch: {
    'registerRequest.curp'(/* data */) {
      // this.curpInputChange(data)

    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    recaptchaVerified(val) {
      if (val) {
        this.captchaError = false
      }
    }
  },

  mounted() {
    if (this.accountStore.loggedIn) {
      this.$router.push({name: 'home'})
    }

    if (this.accountStore.googleRegisterRequested) {
      this.initFillForm(this.accountStore.googleUserData)
    }

    if (this.accountStore.facebookRegisterRequested) {
      this.initFillForm(this.accountStore.facebookUserData)
    }

    window.onpopstate = () => {
      this.cancelRegisterWitGoogleOrFacebook()
    }
  },

  methods: {
    ...mapActions('account', ['registerUser', 'cancelRegisterWitGoogleOrFacebook', 'validateEmailAndUsername', 'resendVerificationCode', 'sendRegisterCode', 'getTryAvailable']),
    clickEvent(first, last) {
      console.log(first);
      console.log(last);
      if (first.length && !isNaN(first)) {
        document.getElementById(last).focus();
      }
    },

    async nextStepToRegister() {
      if (this.stepRegister === '') {
        this.captchaError = false

        this.$refs.preregisterForm.validate();
          if (this.preregisterFormValid ) {
            const validacion = await this.validateUniqueCredentials();
              if (validacion === true){
                this.stepRegister = "MediosDeContacto";
              } else {
                this.stepRegister = "";
              }
          }
          return
      }
      if(this.stepRegister === 'MediosDeContacto' ) {
            // this.sendFirtsCode()
            this.stepRegister = "VerificacionContacto";
      }
    },

    // Valida que el correo no este registrado
    async validateUniqueCredentials() {
      let request = {
        username: this.registerRequest.usuario,
        email: this.registerRequest.email,
        client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
      }
      const isValide = await this.validateEmailAndUsername(request)
      return isValide;
    },

    // registra en la base a usuario y envia el codigo de verificacion al correo y celular
    sendFirtsCode() {
      this.registerUser(this.registerRequest)

      let request = {
        curp: this.registerRequest.curp,
        email: this.registerRequest.email,
        phone: this.registerRequest.telefono,
      }
      this.sendRegisterCode(request)
    },

    // Reenvia el codigo a celular y correo
    resentCodeFirst() {
      this.isDisabled = true;
      this.countdown = 10;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(interval);
          this.isDisabled = false;
        }
      }, 1000);
      let request = {
        curp: this.registerRequest.curp,
        email: this.registerRequest.email,
        phone: this.registerRequest.telefono,
      }
      this.sendRegisterCode(request)
    },

    // Envia Los codigos recibidos en el celular y en el email al backend para su validacion
    async resendVerificationCodeSame() {
      let request = {
        curp: this.registerRequest.curp,
        code: this.phoneCode,
        codeEmail: this.emailCode,
      }
      const confirmacion = await this.resendVerificationCode(request)
      if (confirmacion) {
        this.$router.push('/login')
      }
    },


    // Da formato para para help de inputs
    help(message) {
      this.helpMessage = message
      this.showHelpMessage = true
    },

    // Registro con google y facebook, desabilitado por comodidad
   /* initFillForm(userData) {
      this.registerRequest.tipo_persona = this.personTypeItems[0].code
      this.registerRequest.usuario = userData.id
      this.registerRequest.email = userData.email
      this.registerRequest.password = createStrongPassword(
          userData.id,
          this.accountStore.facebookRegisterRequested ? userData.id : userData.email
      )
      this.registerRequest.password_confirm = createStrongPassword(
          userData.id,
          this.accountStore.facebookRegisterRequested ? userData.id : userData.email
      )
      this.registerRequest.nombres = userData.names
      this.registerRequest.apellido_paterno = userData.lastname
      this.validateUniqueCredentials()
    },*/

    /*cancelRegisterWithGoogleOrFacebook() {
      this.cancelRegisterWitGoogleOrFacebook()
    },*/

    getCaptchaSiteKey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY
    },

    verifyReCaptcha() {
      this.recaptchaVerified = true
    },

    expiredRecaptcha() {
      this.recaptchaVerified = false
    },

    // Validacion de curp, verificacion de mayoria de edad y cambio (NO usando)
    async curpInputChange(curp) {
      if (curp.length == 18) {
        this.curpError = false
        this.curpMessage = ''

        try {
          this.curpLoading = true
          let curpResult = await GeneralApi.verifyCurp(curp)
          let years = moment().diff(moment(curpResult.fechaNac, 'DD/MM/YYYY'), 'years')

          if (years >= 18) {
            this.registerRequest.nombres = curpResult.nombres
            this.registerRequest.apellido_paterno = curpResult.apePat
            this.registerRequest.apellido_materno = curpResult.apeMat
          } else {
            this.curpError = true
            this.curpMessage = 'La CURP es de un menor de edad, no es admitido'
          }
        } catch (error) {
          this.curpError = true
          this.curpMessage = 'La CURP no fue encontrada'

          this.registerRequest.nombres = ''
          this.registerRequest.apellido_paterno = ''
          this.registerRequest.apellido_materno = ''
        }
        this.curpLoading = false
      }
    },

    // Cambia el estado del termino y condicones
    showTermsCondDialog(privacyContent = true) {
      this.showTermsDialog = true
      this.privacyContent = privacyContent
    },

    // Retrocede al formulario anterior
    backRegister() {
      this.stepRegister = '';
      this.accountStore.emailOrUsernameValid = false;
      this.registerRequest.email = '';
      this.registerRequest.phone = '';
      this.confirmarTelefono = '';
      this.confirmarEmail = '';
    },

    obtencionEstados(){

    }

  }
};
</script>

<style>
.title_datos {
  font-size: 25px;
}

.custom-input .v-input__slot {
  box-shadow: 0 4px 2px rgba(0, 0, 0, 0.5) !important;
  border-radius: 8px;
  border-color: #ffffff
}

.mb-2{
  color: #616060;
  font-size: 16px;
}

.v-application.fondo_login #rc-anchor-container {
  /* background: rgb(250 250 250 / 18%); */
  border: 0px !important;
}

@media (max-width: 1199px){
  .text-left{
    width: 90% !important;
  }
}
@media (max-width: 431px){
 .pregunta{
    width: 120%;
 }
}
@media (max-width: 991px){
  .confirm{
    width: 100% !important;
  }
  .nota{
    width: 70% !important;
  }
  .ingresocode{
    width: 70% !important;
  }

}
@media (max-width: 767px){

  .nota{
    width: 90% !important;
  }

}

</style>